<template>
  <bim-datepick
    :value="value"
    @input="onInput"
    type="datetime"
    :format="format"
    :placeholder="placeholder"
    :range="range"
    formKey="value"
    :formModel="_self"
  />
</template>

<script>
import validationMixin from '../validation.mixin'
import bimDatepick from '@/components/form/bimDatepick/bimDatepick'
export default {
  name: 'FieldDatePicker',
  mixins: [validationMixin],
  components: {
    bimDatepick,
  },
  props: {
    value: [Array, String, Date],
    placeholder: String,
    range: Boolean,
    format: {
      type: String,
      default: () => 'DD.MM.YYYY HH:mm:ss'
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
      this.$nextTick(this.validate)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
